import { AxiosResponse } from 'axios'
import {useQuery, UseQueryOptions, useMutation, UseQueryResult} from 'react-query'
import { APIEndpoints } from '../constants/api-endpoints'
import { QueryKeys }     from './_query_keys'
import { HttpRequest }  from '../services/_http'

export const useOTTUsersData = (searchOptions?:any, options?: UseQueryOptions): UseQueryResult <any> => {
    
    const method   = 'GET'
    const queryKey = [QueryKeys.USERS,searchOptions]
    
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.Users}`,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus:false,
        cacheTime: 0,
        ...options
    })
}

export const useUpdateOTTUser = (options?: any) => {
    
    const method = 'PUT'
    
    return useMutation(({data, id}: {data: any, id: any})=> HttpRequest({
        url: `${APIEndpoints.Users}/${id}`,
        method,
        data
    }), options)
}

export const useUpdateOTTUserTestStatus = (options?: any) => {
    
    const method = 'PUT'
    
    return useMutation(({data, id}: {data: any, id: any})=> HttpRequest({
        url: `${APIEndpoints.Users}/${id}/test-user`,
        method,
        data
    }), options)
}

export const useDeleteOTTUser = (options?: any) => {
    
    const method = 'DELETE'
    
    return useMutation(({id}: {id: any})=> HttpRequest({
        url: `${APIEndpoints.Users}/${id}`,
        method,
    }), options)
}
